import { create } from 'zustand';

import type { EmailGateAction } from '../types';

type EmailVerificationGateState = {
  isOpen: boolean;
  action: EmailGateAction | null;
  heldAction: EmailGateAction | null;
  openGate: (action: EmailGateAction) => void;
  holdGate: (action: EmailGateAction) => void;
  clearHeldGate: () => void;
  dismissGate: () => void;
};

export const useEmailVerificationGateStore = create<EmailVerificationGateState>((set) => ({
  isOpen: false,
  action: null,
  heldAction: null,

  openGate: (action) => set({ isOpen: true, action, heldAction: null }),

  holdGate: (action) => set({ heldAction: action }),

  clearHeldGate: () => set({ heldAction: null }),

  dismissGate: () => set({ isOpen: false, action: null }),
}));
